import SecurityPolicyPage from '../../src/client/pages/security-policy';

export default SecurityPolicyPage;
